
(function(template){
  define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/ageRestrictionComponent',[
    "Vue",
    "helpers",
    "vuex",
    "vuedate",
    "moment"

  ], function (
    Vue,
    helpers,
    vuex,
    vuejsDatepicker,
    moment
  ) {
    return {
      template: template,
      name: "",
      props: ['customerID', 'service'],
      data: function () {
        return {
          birthdate: '',
          message: ''
        }
      },
      computed: _.extend(
        vuex.mapState(['users', 'usersWithIds', 'guestProfiles', 'OTBactive', 'isAgeValid']), {}),
      components: {
        'datepicker': vuejsDatepicker
      },
      methods: {
        handleAgeRestriction: function (e) {
        var self = this
         var date = moment(self.birthdate,'YYYY-MM-DD', true);
        if(date.isValid()){ 
          helpers.updateUserDob(self.birthdate,self.customerID).then(function (res) {
            self.guestProfiles[self.customerID]['DateOfBirth'] = self.birthdate
            var ageCheck = self.verifyAge(self.service, self.customerID);
            if(self.OTBactive){
              self.$store.commit('setIsAgeValid', ageCheck.isValid);
              if(ageCheck.isValid) self.birthdate = '';
            } 
            self.guestProfiles[self.customerID]['addedByDatePicker'] = true
            self.message = ''
          }).fail(function (err) {
              self.message = self.localization.spaBooking.packageBooking.errors.failedToUpdateDOB
            
          })
         }
        }
      },
      watch: {
        users: function(){
          if(this.OTBactive){
            this.birthdate = "";
            var guestDob = this.guestProfiles[this.customerID].DateOfBirth
            guestDob ? this.birthdate = moment(guestDob).toDate() : ''
            if(!guestDob){
              this.message =  this.localization.spaBooking.packageBooking.ageRestriction['requireDOBMessage'];
            }else{
              this.message = "";
            }
          } 
        }
      },
      beforeMount: function () {
         var guestDob = this.guestProfiles[this.customerID].DateOfBirth
         guestDob ? this.birthdate = moment(guestDob).toDate() : ''
       // // //  this.birthdate?
       // this.birthdate = guestDob
        if(!this.birthdate && this.OTBactive) this.message =  this.localization.spaBooking.packageBooking.ageRestriction['requireDOBMessage'];
        if(!this.OTBactive) this.message =  this.localization.spaBooking.packageBooking.ageRestriction[!this.birthdate ?'requireDOBMessage':'yourDOB']
      }
    }
  })
})('<div class="ageRestriction-div"> <p class="addons-text spa-service-age-restriction-messages">{{message}} </p> <datepicker v-show="OTBactive && !isAgeValid" v-model="birthdate" :format="localStrings.stepper.body.pick.service.details.DateOfBirthFormat" type="date" :placeholder="localStrings.stepper.body.pick.service.details.DateOfBirthFormat" @change="handleAgeRestriction" :editable="false" :clearable="false" ></datepicker> <datepicker v-if="!OTBactive" v-model="birthdate" :format="localStrings.stepper.body.pick.service.details.DateOfBirthFormat" type="date" :placeholder="localStrings.stepper.body.pick.service.details.DateOfBirthFormat" @change="handleAgeRestriction" :editable="false" :clearable="false" ></datepicker> <!-- <datepicker @input="handleAgeRestriction" format="YYYY-MM-DD" :displayFormat="localStrings.stepper.body.pick.service.details.DateOfBirthFormat" placeholder="Select Date" :value="birthdate"></datepicker> --> </div>');
